//
// Imports
//

import * as BrowserUtilities from "@donutteam/browser-utilities";

import * as UserPreferenceClientLib from "../../../libs/client/UserPreference.client.js";

//
// Component
//

export function initialiseSafetySettingsForm(safetySettingsForm: HTMLElement)
{
	const apiUrl = BrowserUtilities.ElementClientLib.getStringDataOrThrow(safetySettingsForm, "apiUrl");

	safetySettingsForm.addEventListener("submit",
		(event) =>
		{
			event.preventDefault();
		});

	const swearFilterInput = BrowserUtilities.ElementClientLib.getElementOrThrow<HTMLInputElement>(safetySettingsForm, `input[name="global::disable_swear_filter"]`);

	swearFilterInput.addEventListener("change", 
		() =>
		{
			UserPreferenceClientLib.updateValue(apiUrl, swearFilterInput, "global::disable_swear_filter", !swearFilterInput.checked);
		});

	const safetyTunnelWarningsInput = BrowserUtilities.ElementClientLib.getElementOrThrow<HTMLInputElement>(safetySettingsForm, `input[name="safety_tunnel::disable_warnings"]`);

	safetyTunnelWarningsInput.addEventListener("change", 
		() =>
		{
			UserPreferenceClientLib.updateValue(apiUrl, safetyTunnelWarningsInput, "safety_tunnel::disable_warnings", !safetyTunnelWarningsInput.checked);
		});

	safetySettingsForm.classList.add("initialised");
}

export function initialiseSafetySettingsForms()
{
	const safetySettingsForms = document.querySelectorAll<HTMLFormElement>(".component-safety-settings-form:not(.initialised)");

	console.log("[SafetySettingsForm] Initialising " + safetySettingsForms.length + " instances...");

	for (const safetySettingsForm of safetySettingsForms)
	{
		try
		{
			initialiseSafetySettingsForm(safetySettingsForm);
		}
		catch (error)
		{
			console.error("[SafetySettingsForm] Error initialising:", safetySettingsForm, error);
		}
	}
}